import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'; 
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'VueFollowButton',
  props: {
    isLoggedIn: { type: Boolean, required: true },
    businessId: { type: Number, required: true },
    mode: { type: String, required: false, default: 'projectDetail' }
  },
  emits: ["unfollow"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const baseUrl = (window as any).baseUrl || '';
const currentPath = window.location.pathname + window.location.search;

const emit = __emit

onMounted(async () => {
  // console.log('VueFollowButton mounted');
  // console.log(props.isLoggedIn);
  // console.log(props.businessId);

  //- ログインしていない場合は早期リターン
  if (!props.isLoggedIn) return;
  if (!props.businessId) return;

  try {
    const response = await axios.get(`${baseUrl}/business-follow/${props.businessId}`);
    isFollowing.value = response.data.is_followed;
  } catch (error) {
    console.error(error);
  }
});

const props = __props;

const isFollowing = ref<boolean | null>(null);
const isTooltipVisible = ref<boolean>(false);
const isSubmitting = ref<boolean>(false);

let tooltipTimer: number | null = null;

/**
 * ツールチップを表示
 */
function showTooltip() {
  if (tooltipTimer) window.clearTimeout(tooltipTimer);
  isTooltipVisible.value = true;
}

/**
 * ツールチップを遅延で非表示
 */
function hideTooltipWithDelay() {
  if (tooltipTimer) window.clearTimeout(tooltipTimer);
  tooltipTimer = window.setTimeout(() => {
    isTooltipVisible.value = false;
  }, 350);
}

/**
 * フォローを送信
 */
async function handleFollow() {
  //- 送信中は早期リターン
  if (isSubmitting.value) return;

  try {
    //- 送信中フラグを立てる
    isSubmitting.value = true;

    const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;

    //- フォローを送信
    const response = await axios.post(
      `${baseUrl}/business-follow/${props.businessId}`,
      {},
      {
        headers: csrf ? {
          'X-CSRF-TOKEN': csrf,
        } : {},
      }
    );

    isFollowing.value = response.data.is_followed;
  } catch (error) {
    console.error(error);
  } finally {
    isSubmitting.value = false;
  }
}

/**
 * フォローを解除
 */
async function handleUnfollow() {
  //- 送信中は早期リターン
  if (isSubmitting.value) return;

  try {
    //- 送信中フラグを立てる
    isSubmitting.value = true;

    const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;

    const response = await axios.delete(
      `${baseUrl}/business-follow/${props.businessId}`,
      {
        headers: csrf ? {
          'X-CSRF-TOKEN': csrf,
        } : {},
      }
    )

    isFollowing.value = response.data.is_followed;

    if (response.data.success && response.data.is_followed === false) {
      emit('unfollow', props.businessId);
    }

  } catch (error) {
    console.error(error);
  } finally {
    isSubmitting.value = false;
  }
}


const __returned__ = { baseUrl, currentPath, emit, props, isFollowing, isTooltipVisible, isSubmitting, get tooltipTimer() { return tooltipTimer }, set tooltipTimer(v) { tooltipTimer = v }, showTooltip, hideTooltipWithDelay, handleFollow, handleUnfollow, ref, onMounted, get axios() { return axios } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})